module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/drop-shadow-test.json
// module id = 355
// module chunks = 199872032726892